import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const authzSubjectPermissionMenuRegistry = {
    core_authzSubjectPermission: {
        label: "Authz Subject Permission",
        link: PAGE_URL.AUTHZ_SUBJECT_PERMISSION_PAGE,
        key: PAGE_URL.AUTHZ_SUBJECT_PERMISSION_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default authzSubjectPermissionMenuRegistry;
